export default ({ COLORS }) => ({
  label: {
    margin: '0 0 5px'
  },
  part: {
    margin: '0 0 20px'
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  optionals: {
    borderTop: '1px solid #e5e5e5',
    marginTop: '20px',
    paddingTop: '20px'
  },
  optional: {
    marginLeft: '5px',
    color: '#a5a5a5'
  }
})
